const urls = {
    current : '',
    zeus_url: 'https://ai.morphle.in',
}

export {urls};

